import type { ComponentProps } from 'react';
import { Input } from '@/components/ui/input';

/**
 * An Input that supports binding to Zod .nullable() values that can be `null`.
 * Without this, Zod validation such as this example is problematic.
 * When the input is empty, the value is `""` (empty string) and not `null`.
 * This causes Zod to fail with as string does not meet min length of 2.
 * @example
 * `name: z.string().min(2).nullable().default(null)`
 */
export const NullableInput = ({
  onChange,
  value,
  ...props
}: Omit<ComponentProps<typeof Input>, 'onChange' | 'value'> & {
  onChange: (value: number | string | null) => void;
  value: number | string | null | undefined;
}) => {
  return (
    <Input
      {...props}
      onChange={(e) => {
        onChange(e.target.value === '' ? null : e.target.value);
      }}
      // Avoids error when value changes from undefined (uncontrolled) to string (controlled).
      // https://github.com/shadcn-ui/ui/issues/410
      value={value ?? ''}
    />
  );
};
